import(/* webpackMode: "eager" */ "/app/apps/root/app/global-error.tsx");
